import React, { Component } from 'react';
import store from '../../store';
import { Modal } from 'react-bootstrap';
import {addCustomerProfile, putReSendOTPRequired} from '../../actions/Signin' 

import '../../../public/css/media/_modal-advisory.scss';
import { mapPrefixNumber, prefixNumber } from '../../utils/utils';

class RequiredModal extends Component {
  state = { 
    countryPrefix: "",
    email: "",
    phone_number: "",
    errors: null,
  }

  handleInputChange(e) {
    const value = e.target.value;
    const name = e.target.name;

      this.setState({ [name]: value });
  }
  handleEnable(){
    if (this.state.email && this.state.phone_number && this.state.phone_number.length >= 7){
      return false
    }
    return true
  }
  componentWillMount(){
    const email = !this.props.email || this.props.email === `${this.props.fb_id}@gmail.com` ? "" : this.props.email;
    const phone_number = this.props.phone_number && prefixNumber(this.props.phone_number.slice(0,3)) ? this.props.phone_number.slice(3) : this.props.phone_number;
    const countryPrefix = this.props.phone_number && prefixNumber(this.props.phone_number.slice(0,3)) ? this.props.phone_number.slice(0,3) : "";

    this.setState({email, phone_number, countryPrefix} ,() => {
      this.setState({
        phone_number: this.state.phone_number && this.state.phone_number.length > 10 ? '' : this.state.phone_number
      })
    })
  }
  componentWillReceiveProps(nextProps){
    const errors = nextProps.error ? nextProps.error.map(errors => errors) : null;
    let updatedErrorList = {}

     if(errors){
     for (var i = 0; i < errors.length; i++) {
        let errkey = errors[i].title
        updatedErrorList[errkey] = errors[i].detail
      }

      this.setState({
        errors: { ...updatedErrorList }
      })
    }
  }

  saveProfile(e) {
    e.preventDefault();
    if (!this.state.countryPrefix) {
      return (
        this.setState({
          errors: { phone_number: 'Please select country prefix' }
        })
      )
    }
    const first_name = this.props.first_name;
    const last_name = this.props.last_name;
    const email = this.state.email;
    const phone_number = this.state.countryPrefix+this.state.phone_number;
    let parameters = [];
    if((!this.props.phone_number || !prefixNumber(this.props.phone_number.slice(0,3))) && (!this.props.email || this.props.email === `${this.props.fb_id}@gmail.com`)){
    // no email and number
     parameters.push({phone_number_update:true,email:email,first_name:first_name,last_name:last_name,phone_number:phone_number})
    }
    if ((!this.props.email || this.props.email === `${this.props.fb_id}@gmail.com`) && (this.props.phone_number || prefixNumber(this.props.phone_number.slice(0,3))) ){
    // no email only
     parameters.push({phone_number_update:false,email:email, first_name:first_name,last_name:last_name})
    }
    if((!this.props.phone_number || !prefixNumber(this.props.phone_number.slice(0,3))) && (this.props.email && this.props.email !== `${this.props.fb_id}@gmail.com`)){
    // no number only
     parameters.push({phone_number_update:true,first_name:first_name,last_name:last_name,phone_number:phone_number})
    }

    if ((this.props.phone_number && !prefixNumber(this.props.phone_number.slice(0,3))) || !this.props.phone_number){
      store.dispatch(putReSendOTPRequired(parameters));
    } else {
      store.dispatch(addCustomerProfile(parameters));
    }
  }

  render() {
    return (
      <Modal show={this.props.show} autoFocus={true} dialogClassName="custom-modal">
        <Modal.Header>
          <Modal.Title>Add Information</Modal.Title>
            <p className="pull-right required-fields">Field is required.</p>
          </Modal.Header>

          <Modal.Body>
              <form className="form-horizontal">
                <section className="modal-body">
                  {!this.props.email || this.props.email === `${this.props.fb_id}@gmail.com` ?
                  <div className="control">
                    <label>Email Address </label>&nbsp;<label className="inline-error-message" >{this.state.errors ? this.state.errors.email : null}</label>
                    <input type="email" onChange={(e) => this.handleInputChange(e)} name="email"value={this.state.email} autoComplete="off"/>
                  </div>
                  : null}
                  {(!this.props.phone_number || !prefixNumber(this.props.phone_number.slice(0,3))) ?
                  <div className="control">
                    <label>Contact Number </label>&nbsp;<label className="inline-error-message">{this.state.errors ? this.state.errors.phone_number : null}</label>
                    <div style={{display:'flex'}}>
                      <div className="mobile-country">
                        <select value={this.state.countryPrefix} onChange={(e) => this.handleInputChange(e)} name="countryPrefix" >
                          <option value="">Prefix</option>
                          {mapPrefixNumber.map(prefix =>
                            <option value={prefix.value}>{prefix.label}</option>
                          )}
                        </select>
                      </div>
                      <input type="text" style={{margin:'0 0px 0px 71px'}} value={this.state.phone_number} maxLength="10" name="phone_number" onChange={(e) => this.handleInputChange(e)} autoComplete="off"/>
                    </div>
                  </div>
                  : null}
                  </section>

                <div className="modal-footer">
                  <button type="submit" onClick={(e) => this.saveProfile(e)} className="btn btn-register btn-orange" disabled={this.handleEnable()}>
                    Save
                  </button> 
                </div>
              </form>
          </Modal.Body>
      </Modal>
    )
  }
}
export default RequiredModal;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/RequiredModal.js
 **/